import { Controller } from "@hotwired/stimulus"

// One shared tooltip for every heat map cell, filled from the hovered or focused cell's data-tip-* attributes.
// Delegated from the wrapper, so hundreds of cells cost no listeners. Fixed-positioned so the grid's scroll box can't
// clip it.
export default class extends Controller {
  static targets = ["tip"]

  show(event) {
    const cell = event.target.closest("[data-tip-title]")
    if (!cell || !this.element.contains(cell)) return

    this.render(cell.dataset)
    this.position(cell)
  }

  hide(event) {
    const cell = event.target.closest("[data-tip-title]")
    if (cell && cell.contains(event.relatedTarget)) return

    this.close()
  }

  // On Escape and on scroll: the tip is fixed-positioned, so it would stay put while its cell scrolls away.
  close() {
    this.tipTarget.classList.add("hidden")
  }

  render({ tipTitle, tipSubtitle, tipLines, tipFootnote }) {
    const tip = this.tipTarget
    tip.replaceChildren()
    tip.append(this.line("div", tipTitle, "font-semibold text-sm"))
    tip.append(this.line("div", tipSubtitle, "text-sg-gray-300 mb-2"))

    for (const [label, value] of JSON.parse(tipLines)) {
      const row = this.line("div", "", "flex justify-between gap-3")
      row.append(this.line("span", label, ""), this.line("span", value, "font-aeonik-fono"))
      tip.append(row)
    }
    if (tipFootnote) tip.append(this.line("div", tipFootnote, "mt-2 pt-2 border-t border-white/15 text-sg-gray-300"))
  }

  line(tagName, text, className) {
    const node = document.createElement(tagName)
    node.textContent = text
    if (className) node.className = className
    return node
  }

  // Above the cell, or below it when there's no room, kept inside the viewport.
  position(cell) {
    const tip = this.tipTarget
    tip.classList.remove("hidden")
    const cellBox = cell.getBoundingClientRect()
    const tipBox = tip.getBoundingClientRect()
    const gap = 8
    const left = Math.min(Math.max(gap, cellBox.left + cellBox.width / 2 - tipBox.width / 2), window.innerWidth - tipBox.width - gap)
    const above = cellBox.top - tipBox.height - gap
    tip.style.left = `${left}px`
    tip.style.top = `${above >= gap ? above : cellBox.bottom + gap}px`
  }
}
